import { BusinessInformation, PersonInformation } from '@/types/entities/entityInfo';
import { ExistingUserData } from '@/domains/user/components/ExistingUserInfoCard/types';
import { EntityTypesEnum } from '@/enums/EntityTypesEnum';

export const transformSearchUserByIdResponse = (
  data: Array<PersonInformation | BusinessInformation>,
  relationshipType: EntityTypesEnum,
): ExistingUserData | null => {
  if (data.length) {
    if (relationshipType === EntityTypesEnum.Person) {
      const { firstName, lastName, socialInsuranceNumber, socialSecurityNumber, id } = data[0] as PersonInformation;
      return {
        id,
        name: `${firstName.value} ${lastName.value}`,
        idNumber: socialSecurityNumber?.value ?? socialInsuranceNumber?.value ?? '',
        //TODO: remove after changing type for configurable entity
        //@ts-ignore
        idNumberType: socialSecurityNumber?.displayTitle ?? socialInsuranceNumber?.displayTitle ?? '',
        entityType: EntityTypesEnum.Person,
      };
    }
    if (relationshipType === EntityTypesEnum.Business) {
      const { name, tin, id } = data[0] as BusinessInformation;
      return {
        id,
        name: name.value,
        idNumber: tin.value,
        //TODO: remove after changing type for configurable entity
        //@ts-ignore
        idNumberType: tin.displayTitle,
        entityType: EntityTypesEnum.Business,
      };
    }
  }
  return null;
};
